import React, {
  createContext,
  useEffect,
  useReducer,
  useRef
} from 'react';
import type { FC, ReactNode } from 'react';
import SplashScreen from 'src/components/SplashScreen';

interface AppContextValue {
  subscriptionSectionRef: any
  executeScroll: any;
}

interface AppProviderProps {
  children: ReactNode;
}

const AppContext = createContext<AppContextValue>({
  subscriptionSectionRef: () => Promise.resolve(),
  executeScroll: () => Promise.resolve(),
});

export const AppProvider: FC<AppProviderProps> = ({ children }) => {
  const subscriptionSectionRef = useRef(null);
  const executeScroll = () => subscriptionSectionRef.current.scrollIntoView({behavior: 'smooth'})

  return (
    <AppContext.Provider
      value={{
        subscriptionSectionRef,
        executeScroll,
      }}
    >
      {children}
    </AppContext.Provider>
  );

}

export default AppContext;